import config from '../config';
import { notifyError, notifySuccess } from '../MyComponents/Toaster';
import axios from 'axios';

const isEmailExist = async (email) => {
    try {
        const checkEmail = await axios.post(`${config.NODE_API_BASE_URL}/wso2/isEmailExists`, {
            email: email
        });

        return checkEmail.data;
    } catch (error) {
        console.error('Error checking if email exists:', error);
        throw new Error('Oops, something went wrong!');
    }
};

const validateEmail = (value) => {
    if (!value) {
        return 'Email is required';
    } else if (!/^\S+@\S+\.\S+$/.test(value)) {
        return 'Invalid email address';
    }
    return undefined;
};

const verifyFace = async (email, faceBase64) => {
    try {
        const verifyFaceID = await axios.post(`${config.NODE_API_BASE_URL}/idAnalyzer/verifyFaceID`, {
            email: email,
            faceBase64: faceBase64
        })

        return verifyFaceID.data.isLogin;

    } catch (error) {

        if (axios.isAxiosError(error)) {
            const responseStatus = error.response?.status;

            if (responseStatus === 401) {
                notifyError('Login Failed');
            } else if (responseStatus === 500) {
                notifyError('Something Went Wrong');
            }

            console.log("responseStatus", responseStatus);
        }

        console.log(error.message);
        console.error(error);
    }
};

const getUserID = async (email) => {

    try {

        const getUserIDRespnse = await axios.post(config.NODE_API_BASE_URL + '/wso2/getUserID', {
            email: email
        })
        // console.log("getUserIDRespnse" ,getUserIDRespnse);
        if (getUserIDRespnse?.data?.userId) {
            return getUserIDRespnse.data.userId;
        } else {

            return 0;
        }


    } catch (error) {

        if (axios.isAxiosError(error)) {
            const responseStatus = error.response?.status;

            if (responseStatus != 200) {
                notifyError("User ID not found");
            }
            console.log("responseStatus", responseStatus);
        }


    }


};

const getUserData = async (userId) => {


    try {

        const getUserDataRespnse = await axios.post(config.NODE_API_BASE_URL + '/wso2/getUserData', {
            userId: userId
        })
        if (getUserDataRespnse?.data) {
            return getUserDataRespnse.data.data;
        } else {

            return 0;
        }


    } catch (error) {

        if (axios.isAxiosError(error)) {
            const responseStatus = error.response?.status;

            if (responseStatus != 200) {
                notifyError("User ID not found");
            }
            console.log("responseStatus", responseStatus);
        }


    }

}

const fetchAllEntityAccountDetails = async (ssoUserID) => {
    if (!ssoUserID) {
        console.error('No user ID provided');
        return;
    }
    try {
        const response = await axios.get(config.NODE_API_BASE_URL +
            `/entity-all/${ssoUserID}`
        );
        const userData = response.data;
        return userData
    } catch (error) {
        console.error('Error fetching user data:', error);
    }
}

const getUserProfiles = async (userId) => {
    try {
        const response = await axios.get(config.NODE_API_BASE_URL + '/wso2/getUserProfiles', {
            userId: userId
        });

        if (response?.data?.data) {
            return response.data.data;
        } else {
            return [];
        }
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const status = error.response?.status;
            if (status && status !== 200) {
                notifyError("User ID not found");
            }
            console.log("Axios error status:", status);
        } else {
            console.error("Unexpected error", error);
        }
        return [];
    }
};


const isRecaptchaVerified = async (captchaValue) => {
    try {
        const verifyRecaptcha = await axios.post(config.NODE_API_BASE_URL + '/verifyRecaptcha', {
            captchaValue: captchaValue
        });

        return verifyRecaptcha.data;
    } catch (error) {
        // Handle errors here
        console.error('Error verifying reCAPTCHA:', error);

        // You can throw the error again if you want to propagate it to the caller
        throw new Error('Oops, something went wrong!');
    }
};


const validateKycToken = async (userId, kycToken) => {
    try {
        const response = await axios.post(`${config.NODE_API_BASE_URL}/wso2/validateKycToken`, {
            userId: userId,
            kycToken: kycToken
        });

        if (response.data?.status === 1) {
            return response.data.data;
        } else {
            notifyError(response.data?.msg || "Validation failed");
            return null;
        }
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const msg = error.response?.data?.msg || "Validation failed";
            notifyError(msg);
        } else {
            console.error('Error validating KYC token:', error);
            notifyError('Something went wrong during validation');
        }
        return null;
    }
};

const verifyFaceEnhanced = async (userId, faceImageBlob) => {
    try {
        const formData = new FormData();
        formData.append('userId', userId);
        formData.append('faceImage', faceImageBlob);

        const response = await axios.post(`${config.NODE_API_BASE_URL}/idAnalyzer/verifyFaceEnhanced`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        return response.data;

    } catch (error) {
        if (axios.isAxiosError(error)) {
            const responseStatus = error.response?.status;
            const errorMsg = error.response?.data?.msg || 'Verification Failed';

            if (responseStatus === 422) {
                notifyError(errorMsg);
            } else if (responseStatus === 500) {
                notifyError('Internal Server Error during verification');
            } else {
                notifyError(errorMsg);
            }
            console.log("responseStatus", responseStatus);
        }
        console.error('Error in enhanced face verification:', error);
        return { biometric: false, msg: 'Error occurred during verification' };
    }
};

const FREE_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.co.in',
  'hotmail.com',
  'hotmail.co.uk',
  'outlook.com',
  'aol.com',
  'mail.com',
  'protonmail.com',
  'proton.me',
  'icloud.com',
  'me.com',
  'mac.com',
  'yandex.com',
  'yandex.ru',
  'gmx.com',
  'gmx.de',
  'web.de',
  'inbox.com',
  'zoho.com',
  'rediffmail.com',
  'live.com',
  'live.co.uk',
  'live.in',
  'msn.com',
  'ymail.com',
  'rocketmail.com',
  'btinternet.com',
  'ntlworld.com',
  'talktalk.net',
  'virginmedia.com',
  'blueyonder.co.uk',
  'tiscali.co.uk'
];

const isBusinessEmail = (email) => {
  try {
    if (!email) return false;
    
    const domain = email.split('@')[1]?.toLowerCase();
    if (!domain) return false;
    
    // Check educational and government domains
    if (domain.endsWith('.edu') || 
        domain.includes('.ac.') || 
        domain.endsWith('.gov') || 
        domain.endsWith('.gov')) {
      return true;
    }
    
    // Check if it's a free email domain
    return !FREE_EMAIL_DOMAINS.includes(domain);
    
  } catch (error) {
    console.error('Error checking business email:', error);
    return false;
  }
};

export { isEmailExist, validateEmail, verifyFace, verifyFaceEnhanced, getUserID, getUserData, fetchAllEntityAccountDetails, getUserProfiles, isRecaptchaVerified, validateKycToken, isBusinessEmail };
